import React from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { Tooltip, Icon } from '@mui/material'
const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}))

function MatxTooltip(props) {
  const classes = useStyles()

  return <Tooltip arrow placement="top-end" classes={classes} {...props} />
}

export function TooltipIcon(props) {
  return (
    <MatxTooltip {...props}>
      <Icon color="primary" style={{ cursor: 'help' }} className="my-2 ml-2">
        {' '}
        info{' '}
      </Icon>
    </MatxTooltip>
  )
}

export function TooltipIconWrapper({ children, ...props }) {
  return (
    <div className="flex">
      <span style={{ flex: 1 }}>{children}</span>
      <TooltipIcon {...props} />
    </div>
  )
}

export default MatxTooltip
